import { render, staticRenderFns } from "./RetailBackModal.vue?vue&type=template&id=18077da1&scoped=true"
import script from "./RetailBackModal.vue?vue&type=script&lang=js"
export * from "./RetailBackModal.vue?vue&type=script&lang=js"
import style0 from "./RetailBackModal.vue?vue&type=style&index=0&id=18077da1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18077da1",
  null
  
)

export default component.exports